import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MenuOption} from "../main-layout/menu-option";
import {Router} from "@angular/router";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";

@Component({
  selector: 'app-top-nav-menu-item',
  templateUrl: './top-nav-menu-item.component.html',
  styleUrl: './top-nav-menu-item.component.scss'
})
export class TopNavMenuItemComponent implements OnInit {
  @Input() menu: MenuOption;
  @Input() index: number
  @Input() showToggle = true;
  @Output() onAddItem = new EventEmitter()

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild('menuX') menuX: MatMenu;
  timedOutCloser: any;

  constructor(private router: Router
  ) {
  }

  ngOnInit() {
  }

  mouseEnter(trigger) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    // trigger.openMenu();
  }

  mouseLeave(trigger) {
    this.timedOutCloser = setTimeout(() => {
      // trigger.closeMenu();
    }, 50);
  }

  isActiveRoute(route: MenuOption[]) {
    let url = this.router.url?.split('/')
    url?.splice(0, 2)
    const x = route?.map(x => x?.route)?.join(', ').split(',');
    return url.some(entry =>
      x.some(target => target.trim() === entry.trim())
    );
  }


}
